// AppStorage.js
const APP_NAME = 'SPCONSOLE';
const getKey = key => `${APP_NAME}.${key}`;
export const set = (key, value) =>
    localStorage.setItem(getKey(key), value);
export const get = key =>
    localStorage.getItem(getKey(key));
export const remove = key =>
    localStorage.removeItem(getKey(key));